import { MarkdownComponent } from '@/models/markdown';
import { FC } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownProps {
  content: string;
  components?: Record<string, FC<MarkdownComponent>>;
  /* Run after remark-gfm */
  remarkPlugins?: Options['remarkPlugins'];
}

const Markdown: FC<MarkdownProps> = ({
  content,
  components = null,
  remarkPlugins = [],
}) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, ...(remarkPlugins ?? [])]}
      components={components}
    >
      {content}
    </ReactMarkdown>
  );
};

export default Markdown;
